<template>
  <div>
    <div id="header">{{ campaign_type_name[campaign_type].toUpperCase() }}</div>
    <div align="left" class="flex-div">
      <v-icon style="color: var(--link-color);" size="1.8rem">keyboard_arrow_left</v-icon>
      <button @click="closeDetails" style="margin: 0; font-size: 1.8rem; color: var(--link-color);">
        Back
      </button>
    </div>
    <div
      v-if="fillAllFields"
      align="left"
      class="flex-div"
      style="font-size: 2rem; color: crimson"
    >
      Fill up all fields.
    </div>
    <div
      class="flex-div"
      style="display: flex; justify-content: flex-start; flex-wrap: wrap"
    >
      <div class="col-2" style="min-width: 25rem">
        <v-select
          outline
          v-model="validity_period"
          :items="durationItems"
          label="Duration"
          item-value="value"
          item-text="text"
        ></v-select>
        <!-- :error-messages="campaignTypeError" -->
      </div>
      <div class="col-2" style="min-width: 25rem">
        <v-select
          outline
          v-model="template_name"
          :items="template_types"
          label="Template"
          item-value="value"
          item-text="text"
        ></v-select>
        <!-- :error-messages="campaignTypeError" -->
      </div>
    </div>
    <div align="left" class="flex-div">
      <p class="txt">From</p>
      <v-text-field
        v-model="email_from"
        style="max-width: 40.3rem"
        class="txt-field"
        placeholder="info@workd.ai"
        disabled
      />
    </div>
    <div align="left" class="flex-div">
      <p class="txt">Subject</p>
      <v-text-field
        v-model="email_subject"
        style="max-width: 68rem"
        class="txt-field"
        placeholder="email subject goes here"
      />
    </div>
    <div class="btns">
      <div class="find-jobs-button" @click="onRun">
        <b>Run Campaign</b>
      </div>
    </div>
    <div>
      <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
        <div style="text-align: center; width: 100%">
          <span style="padding-right: 1rem"
            ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
          >{{ snackMessage }}
        </div>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { POST_EMAIL_CAMPAIGN } from "../../../Api/admin_api";
export default {
  name: "campaign-details",
  props: {
    campaign_type: String,
    campaign_type_name: Object,
  },
  data() {
    return {
      fillAllFields: false,
      email_subject: null,
      email_from: "info@workd.ai",
      template_params: [],
      validity_period: 1,
      durationItems: [
        {
          text: "1 day",
          value: 1,
        },
        {
          text: "7 days",
          value: 7,
        },
      ],
      template_name: "email-verification",
      template_types: [
        {
          text: "email-verification",
          value: "email-verification",
        },
        {
          text: "email-verification2",
          value: "email-verification2",
        },
        {
          text: "email-verification3",
          value: "email-verification3",
        },
      ],
      bgColor: "",
      timeOut: 2000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
    };
  },
  methods: {
    closeDetails() {
      this.$emit("close-details");
    },
    onRun() {
      const self = this;
      if (!self.email_from || !self.email_subject) {
        self.fillAllFields = true;
        return;
      } else self.fillAllFields = false;
      let params = {
        // campaign_type: self.campaign_type,
        email_subject: self.email_subject,
        email_from: self.email_from,
        template_params: self.template_params,
        template_name: self.template_name,
        validity_period: self.validity_period,
      };
      POST_EMAIL_CAMPAIGN(params)
        .then(function (response) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
          self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = self.$constants.ERROR_MESSAGES.UPDATED;
          self.email_subject = null;
        })
        .catch(function (error) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = error.response.data.description;
        });
    },
  },
};
</script>

<style scoped>
#header {
  margin-top: 3rem;
  margin-left: 4rem;
  margin-bottom: 4rem;
  height: 3.3rem;
  font-size: 2.6rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.27;
  letter-spacing: normal;
  text-align: left;
}
.flex-div {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 4rem;
  margin-bottom: 5.5rem;
}

.txt {
  margin-right: 6rem;
  margin-bottom: 0;
  font-size: 1.6rem;
  font-weight: bold;
  width: 6rem;
}
.txt-field {
  width: 40.3rem;
  padding: 0rem;
  margin: 0rem;
}

.btns {
  display: flex;
  flex-direction: row;
  margin-left: 4rem;
  margin-top: 6.2rem;
}
.find-jobs-button {
  cursor: pointer;
  width: 14.6rem;
  height: 4.2rem;
  border-radius: 2.4rem;
  background-color: var(--action-button-color);
  color: white;
  z-index: 80;
  font-size: 1.6rem;
  font-weight: 100;
  line-height: 1.5;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
}
</style>